import { combineReducers } from '@reduxjs/toolkit';
import { api, feeds } from '../api';
import createTeamReducer from './slice/createTeamSlice';
import overlaySlice from './slice/overlaySlice';
import loginSlice from './slice/loginSlice';
import toastMessageSlice from './slice/toastMessageSlice';

export const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [feeds.reducerPath]: feeds.reducer,
  createTeam: createTeamReducer,
  overlay: overlaySlice,
  login: loginSlice,
  toastMessage: toastMessageSlice
});
